export const BOOK_URL = "https://ncsframework.bigcartel.com/";

export const BOOK = {
    title: "Breaking the Chains",
    subtitle: "A Neuro-Bio-Spiritual Path to Freedom",
    cover: "/assets/book-cover.png",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1450149632596-3ef25a62011a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxnb2xkZW4lMjBnYXRlJTIwYnJpZGdlJTIwc3Vucri2ZQ&ixlib=rb-4.1.0&q=85",
    framework:
        "https://images.unsplash.com/photo-1513434987962-e4c462a265af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbWlzdHklMjBtb3VudGFpbiUyMHJpZGdlJTIwbmF2eSUyMGR1c2t8ZW58MHx8fHwxNzkyNTMzNzE0fDA&ixlib=rb-4.1.0&q=85",
    cta: "https://images.unsplash.com/photo-1511576661531-b34d7da5d0bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxlbXB0eSUyMHJvYWQlMjBoaWdod2F5JTIwZ29sZGVuJTIwc3VucmlzZSUyMGhvcml6b258ZW58MHx8fHwxNzkyNTMzNzE0fDA&ixlib=rb-4.1.0&q=85",
    portrait: "/assets/dr-jaquez.jpg",
    bookBg:
        "https://images.unsplash.com/photo-1675084859768-4630a0d55747?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbWlzdHklMjBtb3VudGFpbiUyMHJpZGdlJTIwbmF2eSUyMGR1c2t8ZW58MHx8fHwxNzkyNTMzNzE0fDA&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    { label: "The Framework", to: "/framework" },
    { label: "Published Work", to: "/published-work" },
    { label: "11th Steppers", to: "/11th-steppers" },
    { label: "Resources", to: "/resources" },
    { label: "Contact", to: "/contact" },
];

export const HEADER_NAV = NAV.filter((n) =>
    ["/", "/about", "/framework", "/resources", "/contact"].includes(n.to),
);

export const CONTACT = {
    phone: "628-628-4938",
    email: "ncsframework@drsergiojaquez.com",
    location: "San Francisco, California",
};

export const STEPPERS = {
    logo: "/assets/steppers-logo.png",
    meeting: "Weekly Meetings – Sundays at 10:00 AM",
    place: "Joseph McPhee Center",
    address: "3550 Cesar Chavez St, San Francisco, CA 94110",
};
